import { loader } from 'graphql.macro'

export default async function destroyTickets ({ dataLoaders, variables }) {
  const schema = loader('./destroyTickets.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      ids: variables.ids
    }
  })
  return response.destroyTickets
}
